<template>
  <div>
    <div id="basePopup" class="modal fade" role="dialog">
      <div class="modal-dialog modal-lg custom-modal-class">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-body">
            <div class="pop_wrapper">
              <div id="left">
                <profile-menu
                  :roleId="roleId"
                  @menuClicked="menuClicked"
                  :activeTab="activeTab"
                  :isDashboardCustomizable="isDashboardCustomizable"
                ></profile-menu>
              </div>
              <div id="right">
                <common-header
                  v-if="profileMenuClicked !== 'logout'"
                  @closepopup="closepopup"
                  @emit-close-event="closePage"
                  @changePage="getPageName"
                  :roleId="roleId"
                  :displaySubheader="displaySubheader"
                  :header="header"
                  :subheader="subheader"
                  :breadcrumb="breadcrumb"
                  :isDashboardCustomizable="isDashboardCustomizable"
                ></common-header>
                <template v-if="profileMenuClicked == 'profile'">
                  <profile-popup
                    ref="profilePopUp"
                    @closedConfirmPopup="redirectProfile"
                    @closepopup="closepopup"
                    @emitBreadCrumb="updateBreadCrumb"
                    @logoutUser="logoutUser"
                    :closeSubPage="closeSubPage"
                  ></profile-popup>
                </template>
                <template v-if="profileMenuClicked == 'team'">
                  <team
                    @closepopup="closepopup"
                    @emitBreadCrumb="updateBreadCrumb"
                    :roleId="roleId"
                    :closeSubPage="closeSubPage"
                  ></team>
                </template>
                <template v-if="profileMenuClicked == 'preferences'">
                  <preferences @closepopup="closepopup" :roleId="roleId"></preferences>
                </template>
                <template v-if="profileMenuClicked == 'notifications'">
                  <notifications
                    @closepopup="closepopup"
                    :roleId="roleId"
                    :regWatchprefTab="regWatchprefTab"
                    :account_id="account_id"
                  ></notifications>
                </template>
                <template v-if="profileMenuClicked == 'billing'">
                  <billing
                    @closepopup="closepopup"
                    :closeSubPage="closeSubPage"
                    @emitBreadCrumb="updateBreadCrumb"
                    :roleId="roleId"
                  ></billing>
                </template>
                <template v-if="profileMenuClicked == 'services'">
                  <services @closepopup="closepopup" :roleId="roleId"></services>
                </template>
                <template v-if="profileMenuClicked == 'dashboard'">
                  <dashboard @closepopup="closepopup" :roleId="roleId"></dashboard>
                </template>
                <template v-if="profileMenuClicked == 'tour'">
                  <virtual-tour @closepopup="closepopup" :roleId="roleId"></virtual-tour>
                </template>
              </div>
            </div>
          </div>
        </div>
        <loader :loadingStatus="loaderStatus"></loader>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import EventBus from '../../utils/event-bus';
import Loader from '../UIComponents/Loader.vue';
import VirtualTour from '../VirtualTour/VirtualTour.vue';
import ProfileMenu from './ProfileMenu.vue';
import ProfilePopup from './ProfilePopup.vue';
import Team from './Team/Team.vue';
import Preferences from './Preferences.vue';
import Notifications from './ProfileNotification.vue';
import CommonHeader from './Header.vue';
import Billing from './Billing.vue';
import Services from './Services.vue';
import Dashboard from './Dashboard.vue';
import { isDashboardCustomizable } from '../../apis/dashboardCustomization';

export default {
  props: {
    regWatchprefTab: String,
    userAction: String,
    roleId: Number,
    account_id: Number
  },
  components: {
    Loader,
    ProfileMenu,
    ProfilePopup,
    Team,
    Preferences,
    Notifications,
    CommonHeader,
    Billing,
    Services,
    Dashboard,
    VirtualTour
  },
  data() {
    return {
      holdRoute: '',
      profileMenuClicked: '',
      header: '',
      subheader: '',
      breadcrumb: '',
      activeTab: '',
      closeSubPage: '',
      displaySubheader: true,
      loaderStatus: false,
      dashboardCustomizable: null,
      isDashboardCustomizable: false
    };
  },
  async mounted() {
    this.$root.$on('selectedMenu', (data) => {
      this.menuClicked(data);
    });
    $('#basePopup').on('hidden.bs.modal', () => {
      $('.modal-backdrop').remove();
    });
    $('#basePopup').on('show.bs.modal', () => {
      this.checkDashboardCustomizable();
    });
  },
  watch: {
    userAction() {
      if (this.userAction) {
        this.menuClicked(this.userAction);
      }
    }
  },
  methods: {
    redirectProfile(closeBasePopup) {
      if (closeBasePopup === 'closeBasePopup') {
        this.reset();
      } else {
        this.redirectRoute(this.holdRoute);
      }
    },
    validateConfirmPopUp() {
      if (this.activeTab === 'profile' && !this.$refs.profilePopUp.disableButtonForProfile) {
        return false;
      }
      return true;
    },
    reset() {
      this.holdRoute = '';
      this.activeTab = '';
      this.profileMenuClicked = false;
      this.$emit('popUpClosed');
      $('#basePopup').modal('hide');
    },
    closepopup(closeBasePopup) {
      if (this.validateConfirmPopUp()) {
        this.reset();
      } else {
        this.$refs.profilePopUp.toggleConfirmPopUp(closeBasePopup);
      }
    },
    logoutUser() {
      this.$emit('logoutUser');
    },
    menuClicked(data) {
      this.holdRoute = data;
      if (this.validateConfirmPopUp()) {
        this.redirectRoute(data);
      } else {
        this.$refs.profilePopUp.toggleConfirmPopUp();
      }
    },
    redirectRoute(data) {
      this.activeTab = data;
      this.profileMenuClicked = data;
      if (data === 'team') EventBus.$emit('resetTeams');
      if (this.validateLogout(data)) {
        this.validateHeader(data);
        this.updateBreadCrumb(false);
      }
    },
    validateHeader(data) {
      this.header = data;
      this.subheader = data;
      if (data !== 'profile' && data !== 'tour') {
        this.header = 'Account Settings';
        this.displaySubheader = true;
      } else if (data === 'tour') {
        this.header = 'Virtual Tour';
        this.displaySubheader = false;
      } else {
        this.displaySubheader = false;
      }
    },
    updateBreadCrumb(breadcrumb) {
      this.breadcrumb = breadcrumb;
      this.closeSubPage = '';
    },
    validateLogout(data) {
      if (data === 'logout') {
        this.loaderStatus = true;
        this.$emit('logoutUser');
        return false;
      }
      return true;
    },
    closePage() {
      this.closeSubPage = 'close';
    },
    getPageName(pageName) {
      this.menuClicked(pageName);
    },
    async checkDashboardCustomizable() {
      this.isDashboardCustomizable = await isDashboardCustomizable(
        JSON.parse(localStorage.getItem('userData')).account_id,
        JSON.parse(localStorage.getItem('userData')).role_id
      );
      // if (this.isDashboardCustomizable) {
      //   EventBus.$emit('loadDashhboard');
      // }
    }
  }
};
</script>
<style lang="scss" scoped>
#left {
  padding: 10px 0 0;
  background-color: $gray95;
  border-top-left-radius: $radius10;
  border-bottom-left-radius: $radius10;
  width: 230px;
  top: 0;
  position: fixed;
  height: inherit;
  z-index: 1;
}
.pop_wrapper {
  height: 85vh;
}
#right {
  padding: 0px;
  background-color: $deep-white;
  border-top-right-radius: $radius10;
  border-bottom-right-radius: $radius10;
  margin-left: 230px;
}
.modal-body {
  padding: 0px;
}
@media (max-width: 1300px) {
  #left {
    display: none;
  }
  #right {
    border-radius: $radius10;
    margin: 0px;
  }
}
.modal-open .modal {
  overflow: hidden;
}
.custom-modal-class {
  margin-top: 6%;
  width: 85% !important;
}
@media (min-width: 768px) and (max-width: 1024px) {
  .pop_wrapper {
    height: 65vh;
  }
  .modal-dialog {
    vertical-align: top;
    margin-top: 14%;
  }
}
@media screen and (max-width: 767px) {
  .custom-modal-class {
    margin-top: 3%;
    width: 90% !important;
  }
  .pop_wrapper {
    height: 90vh;
  }
}
/* iphoneX landscape  */
@media (device-width: 812px) and (device-height: 375px) {
  .pop_wrapper {
    height: 90vh !important;
  }
  .modal-dialog {
    margin-top: 2% !important;
    width: 95% !important;
  }
}
</style>
